
import type { SVGProps } from 'react';
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#search_svg__a)">
      <path
        fill="#263E6A"
        d="m19.485 20.154-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503 5.47 5.436q1.664-1.667 4.064-1.667 2.402 0 4.068 1.664T15.269 9.5q0 1.042-.369 2.017a5.5 5.5 0 0 1-.97 1.668l6.262 6.261zM9.538 14.23q1.991 0 3.361-1.37t1.37-3.361-1.37-3.36-3.36-1.37q-1.991 0-3.361 1.37T4.808 9.5t1.37 3.36 3.36 1.37"
      />
    </g>
    <defs>
      <clipPath id="search_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSearch;
